import React, { useEffect, useState } from "react";
import { AuthAPI } from "../api";
import { Link } from "react-router-dom";
import { ui, uiHandlers } from "../uiStyles";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [notice, setNotice] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const msg = localStorage.getItem("session_message");
    if (msg) {
      setNotice(msg);
      localStorage.removeItem("session_message");
    }
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");

    setLoading(true);

    try {
      await AuthAPI.login(email, password);
      window.location.href = "/clients-jobs";
    } catch (e) {
      setErr("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ ...ui.page, maxWidth: 1200, paddingTop: 0 }}>
      <div
        style={{
          borderBottom: "1px solid rgba(148,163,184,0.20)",
          padding: "22px 24px",
          marginBottom: 54,
          display: "flex",
          alignItems: "center",
          gap: 14,
        }}
      >
        <div
          style={{
            width: 54,
            height: 54,
            borderRadius: 14,
            background: "#f4c542",
            color: "#071827",
            display: "grid",
            placeItems: "center",
            fontWeight: 900,
            fontSize: 21,
          }}
        >
          JT
        </div>

        <div>
          <div style={{ fontSize: 24, fontWeight: 900, color: "#ffffff", lineHeight: 1.05 }}>
            JobTelesis
          </div>
          <div style={{ fontSize: 14, color: "#9fb0c3", marginTop: 5 }}>
            Operations software for contractors and service businesses
          </div>
        </div>
      </div>

      <div
        style={{
          maxWidth: 680,
          margin: "0 auto 22px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 30, fontWeight: 900, color: "#ffffff", lineHeight: 1.12 }}>
          Everything Connected To The Job.
        </div>

        <div style={{ color: "#9fb0c3", fontSize: 15, marginTop: 12 }}>
          Client → Job → Estimate → Invoice → Payment → Revenue
        </div>
      </div>

      <div style={{ ...ui.card, maxWidth: 520, margin: "0 auto" }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#ffffff" }}>
            Sign in
          </div>
          <div style={{ fontSize: 13, color: "#9fb0c3", marginTop: 6 }}>
            Sign in with your email and password
          </div>
        </div>

        {notice && (
          <div
            style={{
              marginBottom: 14,
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(224,184,79,0.45)",
              background: "rgba(224,184,79,0.10)",
              color: "#f7e7b2",
              fontSize: 13,
            }}
          >
            {notice}
          </div>
        )}

        {err && (
          <div
            style={{
              marginBottom: 14,
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(248,113,113,0.35)",
              background: "rgba(248,113,113,0.08)",
              color: "#fca5a5",
              fontSize: 13,
            }}
          >
            {err}
          </div>
        )}

        <form onSubmit={onSubmit} style={{ display: "grid", gap: 14 }}>
          <input
            type="email"
            placeholder="Email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={ui.input}
            {...uiHandlers.focus}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={ui.input}
            {...uiHandlers.focus}
          />

          <div style={{ textAlign: "right", marginTop: -2 }}>
            <Link to="/forgot-password" style={ui.link}>
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              ...ui.btnPrimary,
              width: "100%",
              opacity: loading ? 0.8 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            {...(!loading ? uiHandlers.primaryHover : {})}
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <div style={{ textAlign: "center", color: "#9fb0c3", fontSize: 13, marginTop: 6 }}>
            Need a workspace?{" "}
            <Link to="/signup" style={{ ...ui.link, fontWeight: 800 }}>
              Create Workspace
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
